import {
  Button,
  Card,
  Col,
  Divider,
  Modal,
  Row,
  Skeleton,
  Space,
  Tooltip,
  Typography,
} from "antd";
import lodash from "lodash";
import { useJobDeposit } from "hook/bailiff/job/action/useJobDeposit";
import numeral from "numeral";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import {
  bailiffJobBanksSelector,
  bailiffJobDetailSelector,
} from "store/bailiff/bailiff/job/bailiff_job.selector";
import {
  orderBailiffAllSelector,
  orderBailiffOpenPaymentSelector,
  orderBailiffQrSelector,
} from "store/bailiff/payment/order/order_bailiff.selector";
//
//component
import QRCodeLogo from "component/component/qr_code_logo";
import TriggerJobPayment from "./trigger/trigger_job_payment";
import ConfirmCountdown from "./component/confirm_countdown";
import TriggerClose from "./trigger/trigger_close";
//redux
//selector
//actions
//utils
//hook
//str
import napas from "asset/img/logo/napas.png";
import vietqr from "asset/img/logo/vietqr.png";
import vivnLogo from "asset/img/logo/vivn.png";
import { DownloadOutlined, QrcodeOutlined } from "@ant-design/icons";
import { useResponsive } from "hook/useResponsive";
import TriggerJobChange from "./trigger/trigger_job_change";

const DialogPaymentConfirm = () => {
  // -------------------------- VAR -----------------------------
  const { mobile } = useResponsive();
  const { handleClose } = useJobDeposit();
  // -------------------------- STATE ---------------------------
  const [selected, setSelected] = useState(0);
  const [payment, setPayment] = useState(null);
  // -------------------------- REDUX ---------------------------
  const open = useSelector(orderBailiffOpenPaymentSelector);
  const detail = useSelector(bailiffJobDetailSelector);
  const qr = useSelector(orderBailiffQrSelector);
  const banks = useSelector(bailiffJobBanksSelector);
  const chunks = lodash.chunk(banks, 21) || [];
  // const open = !!qr;
  const money = payment?.amount;
  const label = "Thanh toán dịch vụ chuyển âm";

  // -------------------------- FUNCTION ------------------------
  const createQrWithBorderAndLogo = (base64) => {
    return new Promise((resolve) => {
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");

      const qrImage = new Image();
      qrImage.crossOrigin = "Anonymous";
      qrImage.src = base64;

      qrImage.onload = () => {
        const originalSize = qrImage.width;
        if (originalSize === 0) {
          resolve(base64); // Return original if size is 0
          return;
        }
        const border = originalSize * 0.05;
        const canvasSize = originalSize + border * 2;

        canvas.width = canvasSize;
        canvas.height = canvasSize;

        // Fill background with white (for the border)
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasSize, canvasSize);

        // Draw the QR code onto the canvas with a margin
        ctx.drawImage(qrImage, border, border, originalSize, originalSize);

        const logoImage = new Image();
        logoImage.crossOrigin = "Anonymous";
        logoImage.src = vivnLogo;

        logoImage.onload = () => {
          const logoSize = originalSize * 0.16; // Logo is 20% of the QR code size
          const logoX = (canvasSize - logoSize) / 2;
          const logoY = (canvasSize - logoSize) / 2;

          // Add a white background for the logo to ensure scannability
          const padding = 5;
          ctx.fillStyle = "white";
          ctx.fillRect(
            logoX - padding,
            logoY - padding,
            logoSize + padding * 2,
            logoSize + padding * 2,
          );

          // Draw the logo
          ctx.drawImage(logoImage, logoX, logoY, logoSize, logoSize);

          resolve(canvas.toDataURL("image/png"));
        };

        logoImage.onerror = () => {
          // If logo fails, return original QR code (with border)
          resolve(canvas.toDataURL("image/png"));
        };
      };

      qrImage.onerror = () => {
        // If QR fails, return empty string or original base64
        resolve(base64);
      };
    });
  };

  const handleDownloadQR = async () => {
    if (!qr) return;
    const finalQr = await createQrWithBorderAndLogo(qr);
    const link = document.createElement("a");
    link.download = "qr-payment.png";
    link.href = finalQr;
    link.click();
  };
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderLeft = () => {
    return (
      <Card>
        <Row gutter={[10, 20]}>
          <Col xl={24} lg={24} md={24} xs={24}>
            <Typography.Title style={{ margin: 0 }} level={4}>
              Thông tin đơn hàng
            </Typography.Title>
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderBlock({
              title: "Tên Tổ Chức",
              value: "CÔNG TY CỔ PHẦN TỔ CHỨC PHÁT TRIỂN VÌ VIỆT NAM",
              row: false,
            })}
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderBlock({ title: "Tên File", value: detail?.name })}
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderBlock({
              title: "Nội dung",
              value: `BLJDP${detail?.id}vivn`,
            })}
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderBlock({
              title: "Kiểu thanh toán",
              value: label,
            })}
          </Col>
          <Divider style={{ margin: 0 }} />
          <Col xl={24} lg={24} md={24} xs={24}>
            {renderBlock({
              title: "Số tiền",
              value: numeral(money).format("0,0") + "đ",
              size: 22,
            })}
          </Col>
        </Row>
      </Card>
    );
  };

  const renderCountDown = () => {
    return <ConfirmCountdown />;
  };

  const renderCancel = () => {
    return (
      <Button
        style={{
          marginTop: 20,
          fontSize: 16,
          textDecoration: "underline",
        }}
        size="large"
        block
        type="text"
        onClick={handleClose}
      >
        Huỷ bỏ
      </Button>
    );
  };

  const renderBlock = ({ title, value, size = 16, row = true }) => {
    const ellipsis = row ? { rows: 1 } : false;
    return (
      <div style={{ display: "flex", flexDirection: "column" }}>
        <Typography.Text style={{ fontSize: 16 }} type="secondary">
          {title}
        </Typography.Text>
        <Tooltip title={value}>
          <Typography.Text ellipsis={ellipsis} style={{ fontSize: size }}>
            {value}
          </Typography.Text>
        </Tooltip>
      </div>
    );
  };

  // :::::::::::: qr section :::::::::::::

  const renderQRPayment = () => {
    return (
      <div className="confirm-qr-section">
        <Row justify={"center"} gutter={[30, 30]}>
          <Col align="center" xl={24} lg={24} md={24} xs={24}>
            <Typography.Title style={{ margin: 0, color: "#fff" }} level={4}>
              Quét mã QR để thanh toán
            </Typography.Title>
          </Col>
          <Col align="center" xl={24} lg={24} md={24} xs={24}>
            <div
              style={{
                width: "fit-content",
                background: "#fff",
                borderRadius: 15,
                padding: 15,
                gap: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              <img style={{ height: 25 }} src={napas} alt="logo napas" />
              <img style={{ height: 25 }} src={vietqr} alt="logo vietqr" />
            </div>
          </Col>
          <Col align="center" xl={24} lg={24} md={24} xs={24}>
            <div
              style={{
                width: "fit-content",
                background: "#fff",
                borderRadius: 15,
                padding: 6,
                gap: 20,
                display: "flex",
                alignItems: "center",
              }}
            >
              {qr ? (
                <QRCodeLogo base64={qr} />
              ) : (
                <Skeleton.Node
                  style={{ width: 280, height: 280, borderRadius: 20 }}
                  active
                />
              )}
            </div>
          </Col>
          <Col align="center" xl={15} lg={15} md={24} xs={24}>
            <Button
              className="border-[1px] border-white bg-transparent hover:!bg-red-200 hover:!text-black"
              type="primary"
              onClick={handleDownloadQR}
              disabled={!qr}
              icon={<DownloadOutlined />}
            >
              Lưu ảnh QR Thanh toán
            </Button>
          </Col>
          <Col align="center" xl={15} lg={15} md={24} xs={24}>
            <Typography.Text style={{ color: "#fff", fontSize: 16 }}>
              <QrcodeOutlined /> Sử dụng Ví điện tử như{" "}
              <b>Momo, Zalo Pay, Viettel Pay</b> hoặc <b>Ứng dụng ngân hàng</b>{" "}
              để quét mã
            </Typography.Text>
          </Col>
          <Col
            className="flex flex-col gap-2"
            align="center"
            xl={19}
            lg={19}
            md={24}
            xs={24}
          >
            <Typography.Text
              className="text-bold text-center"
              style={{ fontSize: 12, color: "yellow" }}
            >
              Chỉ thanh toán được một lần, hệ thống ngân hàng có thể bị chậm trễ
              vài phút, xin vui lòng chờ trong giây lát khi bạn đã thanh toán
              thành công.
            </Typography.Text>

            <Typography.Text
              style={{ color: "#fff", fontSize: 12 }}
              className="italic"
            >
              Gặp khó khăn khi thanh toán ? Vui lòng liên hệ admin
            </Typography.Text>
          </Col>
        </Row>
      </div>
    );
  };

  const renderBanks = () => {
    const size = 10;
    return (
      <Card style={{ marginTop: 10 }}>
        <Row>
          {chunks?.[selected]?.map((bank) => (
            <Col flex={"auto"} key={bank?.id}>
              <img src={bank?.logo} style={{ height: 30 }} alt="bank" />
            </Col>
          ))}
          <Col style={{ marginTop: 20 }} align="center" span={24}>
            <Space>
              {chunks?.map((chunk, index) => {
                const chosen = index === selected;
                const background = chosen ? "#e5191e" : "#f2f2f2";
                return (
                  <div
                    key={index}
                    onClick={() => setSelected(index)}
                    style={{
                      width: size,
                      height: size,
                      borderRadius: "100%",
                      background,
                      cursor: "pointer",
                    }}
                  />
                );
              })}
            </Space>
          </Col>
        </Row>
      </Card>
    );
  };

  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      width={1000}
      onCancel={handleClose}
      title={null}
      open={open}
      footer={null}
      closeIcon={null}
      style={{ zIndex: 99 }}
      destroyOnClose
    >
      <Row gutter={[30, 30]}>
        <Col xl={8} lg={8} md={24} xs={24}>
          {renderLeft()}
          {renderCountDown()}
          {!mobile && renderCancel()}
        </Col>
        <Col xl={16} lg={16} md={24} xs={24}>
          {renderQRPayment()}
          {mobile && renderCancel()}
          {renderBanks()}
        </Col>
      </Row>
      <TriggerJobPayment />
      <TriggerJobChange setPayment={setPayment} />
      <TriggerClose />
    </Modal>
  );
};
export default DialogPaymentConfirm;
